import { Result, Schema, SchemaIssue } from 'effect'

const formatIssue = SchemaIssue.makeFormatterStandardSchemaV1()

export function decodeSchemaFields<S extends Schema.ConstraintDecoder<unknown>>(
  schema: S,
  input: unknown
): Result.Result<S['Type'], Partial<Record<keyof S['Type'], string>>> {
  return Result.mapError(
    Schema.decodeUnknownResult(schema, { errors: 'all' })(input),
    ({ issue }) =>
      Object.fromEntries(
        formatIssue(issue).issues.flatMap(({ path, message }) => {
          const field = path?.[0]
          return typeof field == 'string' ? [[field, message]] : []
        })
      ) as Partial<Record<keyof S['Type'], string>>
  )
}
